// @flow
import { CHECKOUT_PAPER } from '../../Billing/Styles/PlansHome.Style';

const twilioNumberHomeStyles = {
  root: (theme) => ({
    minHeight: '100vh',
    display: 'flex'
  }),
  header: (theme) => ({
    marginRight: theme.spacing(4),
    color: 'red',
    textShadow: '0px 0 4px hsl(0deg 0% 0% / 12%)',
    '&.light': {
      color: theme.palette.primary.main,
      background: 'red'
    },
    '& a': {
      textDecoration: 'none',
      color: 'inherit'
    },
    [theme.breakpoints.down('sm')]: {
      whiteSpace: 'nowrap',
      overflowX: 'scroll',
      maxWidth: '50vw'
    }
  }),
  gridPaper: (theme) => ({
    ...theme.squareplan.window.width,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    marginBottom: 50,
    minHeight: 200,
    marginLeft: theme.spacing(2)
  }),
  welcomeText: (theme) => ({
    marginBottom: theme.spacing(3),
    fontSize: '1rem'
  }),
  tableCell: (theme) => ({
    borderBottom: 'none',
    fontSize: '1rem',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      fontSize: '0.9rem'
    }
  }),
  headerCell: (theme) => ({
    borderBottom: 'none',
    backgroundColor: 'white',
    fontSize: '1.25rem',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      fontSize: '1.1rem'
    }
  }),
  phoneNumberCell: (theme) => ({
    borderBottom: 'none',
    fontSize: '1rem',
    minWidth: '100px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      fontSize: '0.9rem'
    }
  }),
  buttonCell: (theme) => ({
    borderBottom: 'none',
    fontSize: '1rem',
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      fontSize: '0.9rem'
    }
  }),
  inputCtr: (theme) => ({
    textAlign: 'left'
  }),
  formContainer: (theme) => ({
    padding: theme.spacing(2.5),
    paddingTop: theme.spacing(0),
    textAlign: 'left'
  }),
  formLabel: (theme) => ({
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
    display: 'block'
  }),
  horizontalFormContainer: (theme) => ({
    marginTop: theme.spacing(0.5)
  }),
  searchInput: (theme) => ({
    marginTop: theme.spacing(0.5)
  }),
  countryDropdown: (theme) => ({
    marginTop: theme.spacing(5),
    marginLeft: theme.spacing(2.5),
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(2)
    }
  }),
  localitySearchBox: (theme) => ({
    width: 'auto',
    maxWidth: 700,
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2.5),
    marginRight: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(2),
      fontSize: '16px'
    }
  }),
  areaCodeSearchBox: (theme) => ({
    width: 700 + theme.spacing(4) * 3,
    marginLeft: theme.spacing(2)
  }),
  contentCtr: (theme) => ({
    flexGrow: 1,
    width: '100%',
    textAlign: 'center',
    maxWidth: 900,
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      minWidth: 0,
      padding: 0
    }
  }),
  tableCtr: (theme) => ({
    width: 800,
    textAlign: 'center',
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      maxWidth: '84vw'
    }
  }),
  paperText: (theme) => ({
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    marginLeft: theme.spacing(2)
  }),
  table: (theme) => ({
    maxWidth: 800,
    maxHeight: 440,
    overflow: 'auto',
    borderBottom: 'none',
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(0),
    marginTop: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      width: '100%',
      marginLeft: 0,
      marginRight: 0
    }
  }),
  actionButtons: (theme) => ({
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1)
  }),
  formPaper: (theme) => ({
    ...CHECKOUT_PAPER,
    width: 'auto',
    maxWidth: 900,
    padding: theme.spacing(3),
    marginTop: theme.spacing(4),
    marginLeft: 'auto',
    marginRight: 'auto',
    '& p, & h2, & h3': {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5)
    },
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      minWidth: 0,
      margin: theme.spacing(2),
      padding: theme.spacing(2)
    }
  })
};

export default twilioNumberHomeStyles;